<template>
  <div role="button" class="multiselectcomponent input-group form-floating" :class="{'has-validation': errorMessage,'is-invalid': errorMessage}" v-if="valueModel">
    <label :for="'autocomplete-' + $.uid" style="width: 100%" class="">
      {{props.label}} {{ props.required ? '*' : '' }}
    </label>
    <multiselect
      v-model="valueModel.value"
      :name="'autocomplete-' + $.uid"
      :options="options"
      :track-by="props.optionsTrackBy"
      :label="props.optionsLabel"
      :custom-label="props.optionsLabelFunction"
      :searchable="true"
      :close-on-select="props.closeOnSelect"
      :show-labels="props.showLabels"
      :placeholder="props.placeholder"
      :aria-label="props.placeholder"
      :allow-empty="props.allowEmpty"
      :selectLabel="props.selectLabel"
      selectGroupLabel="Cliquez pour sélectionner le groupe"
      deselectLabel="Retirer"
      selectedLabel="Selectionné"
      :required="props.required"
      :class="{'is-invalid': errorMessage}"
      :internal-search="false"
      :limit="props.multiple ? 30 : 1"
      :showNoOptions="false"
      :reset-after="props.resetAfter"
      @search-change="searchChange"
      @open="searchChange('')"
      @select="select"
      :hide-selected="props.hideSelected"
      :multiple="props.multiple"
    >
    <template #noResult>
      <span>{{ props.noElementFoundText }}</span>
    </template>
    <template #singleLabel="{ option }" v-if="allowClear">
      <span class="d-flex justify-content-between w-100">
        <span>{{ props.optionsLabelFunction ? props.optionsLabelFunction(option) : option }}</span>
        <span class="" @mousedown.prevent.stop="valueModel.value = null"><i class="fa fa-close"></i></span>
      </span>
  </template>
  </multiselect>
    <div class="invalid-feedback">{{ errorMessage }}</div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { useField } from 'vee-validate';
import Multiselect from 'vue-multiselect'

const model = defineModel<string[]>({ required: false, default: () => [] })
const options = defineModel<unknown[] | (string|number) []>('options',{ required: false, default: () => [] })

const emit = defineEmits<{
  (e: 'search-change', query: string): void
  (e: 'select', option: unknown): void
}>();

const searchChange = (query: string) => {
  emit('search-change', query);
}

const select = (selectedOption: unknown) => {
  emit('select', selectedOption);
}

const props = withDefaults(defineProps<{
  label: string;
  valueKey?: AllTypeKeys;
  placeholder?: string;
  duplicateTagText?: string;
  invalidTagText?: string;
  tagVariant?: string;
  required?: boolean;
  closeOnSelect?: boolean;
  allowEmpty?: boolean;
  showLabels?: boolean;
  noElementFoundText?: string;
  tagValidator?: (tag: string) => boolean;
  optionsTrackBy?: string;
  optionsLabel?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  optionsLabelFunction?: (obj: any) => string;
  resetAfter?: boolean;
  selectLabel?: string;
  hideSelected?: boolean;
  allowClear?: boolean;
  multiple?: boolean;
}>(), {
  placeholder: '',
  duplicateTagText: 'Choix déjà existant',
  invalidTagText: 'Choix déjà existant',
  tagVariant: 'secondary',
  required: false,
  closeOnSelect: true,
  allowEmpty: true,
  showLabels: true,
  noElementFoundText: 'Aucun élement trouvé',
  resetAfter: false,
  selectLabel: 'Cliquez pour ajouter',
  hideSelected: false,
  allowClear: false,
  multiple: false
})

const { value, errorMessage } = props.valueKey !== undefined ? useField<string|number|null>(() => props.valueKey!) : {};

const valueModel = computed(() => {
  if(props.valueKey && value) return value;
  else return model;
})
</script>

<style>
  .multiselectcomponent label {
    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
    z-index: 51 !important;
  }
  .multiselectcomponent .multiselect__select {
    margin-top: 12px !important;
  }
  .multiselectcomponent .multiselect__tags {
    min-height: calc(3.5rem + 2px);
    border-radius: 0.8rem;
    border-color: #86868b !important;
    padding-top: calc(1.5rem + 4px);
  }

  .multiselectcomponent .multiselect__tag {
    margin-bottom: 0px !important;
  }
</style>
